export const INTRODUCTION_LIST = [{
  img: 'introduction_01.png',
  title: '高性能的自选股同步实现',
  paragraph: ['高可用的内存数据库Redis+异步入库程序，满足系统高速处理的同时，减少与数据库MySQL的交互；', '另外，通过灵活的消息队列与同步版本管理，确保自选股数据不丢。']
}, {
  img: 'introduction_02.png',
  title: '便捷的手机与PC绑定操作',
  paragraph: ['1、用户在手机端登录/在PC端登录资金账号后，自选股即同步至云端；后续自选股操作（新增、删除、更改分组）后，请求相关接口实时同步至云端；', '2、用户在PC端手动绑定手机号后，即可将手机上的自选股同步至PC，两端实时同步；']
}, {
  img: 'introduction_03.png',
  title: '多市场代码自动转换',
  paragraph: ['同花顺提供统一标准的自选股同步转换方案，默认提供初始设置，可解决大部分同步问题。', '另外，可在策略设置中台，通过精准匹配、智能匹配、市场匹配等方式，自定义设定同步策略，解决剩余特有市场ID同步转换问题']
}];
const imgUrl = 'advantage_01.png';
export const ADVANTAGE_LIST = [{
  img: imgUrl,
  icon: 'advantage_icon_01.png',
  title: '操作便捷无感知',
  paragraph: ['APP端，登录手机号即可一键同步', 'PC端，绑定手机号即可一键同步；', '默认提供智能转换策略，可自动匹配市面上超过95%的第三方自选股服务。']
}, {
  img: imgUrl,
  icon: 'advantage_icon_02.png',
  title: '同步快速且精准',
  paragraph: ['客户端/云端，双向秒级同步，弱网或断网情况下，支持本地储存；', '增量更新，节省流量；', '海量的消息持久化和堆积机制，始终保持高性能。']
}, {
  img: imgUrl,
  icon: 'advantage_icon_03.png',
  title: '兼容第三方服务',
  paragraph: ['提供自选股代码转换功能，支持精准匹配、智能匹配、市场匹配模式，允许券商自定义编辑，覆盖全APP自选股应用场景。']
}];
export const CASES_LIST = [{
  icon: 'zszq_icon.png',
  title: '浙商证券',
  desc: '使用同花顺自选股同步方案后，用户切换使用APP与PC时，可无缝连接操作极大地提升了用户体验。'
}, {
  icon: 'yhzq_icon_large.png',
  title: '银河证券',
  desc: '同花顺自选股同步方案，可自动处理服务器与客户端同步逻辑，无需二次调整。另外还支持特殊证券品种的兼容，大大减轻了运维人员的工作压力。'
}, {
  icon: 'dfzq_icon_large.png',
  title: '东方证券',
  desc: '同花顺提供的自选股统一规范，能很好地解决东方证券APP与PC客户端自选股同步的问题，智能码表转换服务为我们兼容多市场代码省了不少事。'
}];